document.addEventListener("DOMContentLoaded", () => {
	function onSizeSelect({ size = "Vælg størrelse", variantId, productId }) {
		if (!productId) return;

		const openSizeModalButtons = document.querySelectorAll(
			`#openSizeModalBtn--${productId}`
		);
		// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.2) - textContent, så et variantnavn med fx "<" ikke bliver læst som HTML
		// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.4) - audit 5: kun teksten skiftes, så pilen (SVG) bliver stående
		openSizeModalButtons.forEach(button => {
			const textNode = Array.from(button.childNodes).find(node => node.nodeType === Node.TEXT_NODE && node.nodeValue.trim());
			if (textNode) textNode.nodeValue = size;
			else button.textContent = size;
		});

		const sizeModals = document.querySelectorAll(`#sizeModal--${productId}`);
		sizeModals.forEach(sizeModal => {
			sizeModal.style.display = "none";
		});

		if (variantId) {
			const variantIdInputs = document.querySelectorAll(
				`#variantId--${productId}`
			);
			variantIdInputs.forEach(variantIdInput => {
				variantIdInput.value = variantId;
			});
		}
	}

	const getIdFromElementId = id => id.split("--")[1];

	document.addEventListener("click", event => {
		// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.2) - punkt 9: valg af størrelse fanges her i den fælles lytter.
		// Før fik hver størrelsesknap en ny lytter, hver gang vælgeren blev åbnet, og de blev aldrig fjernet.
		const sizePicker = event.target.closest('[id^="sizeModal--"] [data-size]');
		if (sizePicker) {
			onSizeSelect({
				size: sizePicker.dataset.size,
				variantId: sizePicker.value,
				productId: getIdFromElementId(sizePicker.closest('[id^="sizeModal--"]').id),
			});
			return;
		}

		// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.4) - audit 5: closest, så et klik på pilen (SVG) inde i knappen også tæller
		const openButton = event.target.closest('[id^="openSizeModalBtn--"]');
		const addButton = event.target.closest('[id^="addToCartBtn--"]');

		if (openButton) {
			/* Open/close modal */
			const productId = getIdFromElementId(openButton.id);

			document.querySelectorAll(`#sizeModal--${productId}`).forEach(sizeModal => {
				sizeModal.style.display = sizeModal.style.display === "block" ? "none" : "block";
			});
		} else if (addButton) {
			/* Add to cart */
			const productId = getIdFromElementId(addButton.id);

			const variantIdInputs = Array.from(
				document.querySelectorAll(`#variantId--${productId}`)
			);

			if (variantIdInputs.some(input => !input.value)) {
				// Error
				event.preventDefault();
				alert("Vælg venligst en størrelse");
				return;
			}
			// Success
			onSizeSelect({ productId });
		}
	});
});
